import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

const READER_ID = "qr-camera-reader";

const swallowAbort = (e) => {
  const r = e.reason;
  const msg = String(r?.message || r || "");
  if (r?.name === "AbortError" || msg.includes("play() request was interrupted")) e.preventDefault();
};

export const CameraScanner = ({ onResult, onError }) => {
  const cb = useRef({ onResult, onError });
  cb.current = { onResult, onError };

  useEffect(() => {
    window.addEventListener("unhandledrejection", swallowAbort);
    const scanner = new Html5Qrcode(READER_ID);
    let done = false;
    const started = scanner
      .start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 220, height: 220 } }, (text) => {
        if (done) return;
        done = true;
        cb.current.onResult(text);
      }, () => {})
      .then(() => true)
      .catch((e) => { cb.current.onError(String(e?.message || e)); return false; });
    return () => {
      started
        .then((ok) => (ok ? scanner.stop().then(() => scanner.clear()) : null))
        .catch(() => {})
        .finally(() => setTimeout(() => window.removeEventListener("unhandledrejection", swallowAbort), 1000));
    };
  }, []);

  return <div id={READER_ID} className="w-full rounded-lg overflow-hidden bg-slate-900 min-h-[240px]" data-testid="qr-camera-view" />;
};
